import DisplayWrapper from "@/components/wrappers/DisplayWrapper";
import { useFilterSearchParams, useUpdateFilterSearchParams } from "@/utils/hooksUtils";
import { Card } from "antd";
import { COMMON_AGENT_FILTER_SEARCH_PARAMS } from "../../agent/api";
import { AgentStatus } from "../../agent/enums";
import { useCurrentAgentAccount } from "../../auth/hooks";
import { DEFAULT_CHINA_COMPETITION_QUERY_PARAMS } from "../api";
import { ChinaCompetitionFilter } from "../components/ChinaCompetitionFilter";
import { ChinaCompetitionTable } from "../components/tables/ChinaCompetitionTable";
import { ChinaCompetitionResultFilterPageRequest } from "../types";

export const ChinaCompetitionContainer = () => {
  const agentUserAccount = useCurrentAgentAccount();

  const searchParams = useFilterSearchParams<ChinaCompetitionResultFilterPageRequest>({
    params: ["orderBy", "orderDirections", ...COMMON_AGENT_FILTER_SEARCH_PARAMS],
    defaultQueryParamsObject: DEFAULT_CHINA_COMPETITION_QUERY_PARAMS,
  });

  const updateSearchParams = useUpdateFilterSearchParams<ChinaCompetitionResultFilterPageRequest>(
    DEFAULT_CHINA_COMPETITION_QUERY_PARAMS,
  );

  return (
    <DisplayWrapper itemLoaded={true} isError={agentUserAccount?.agent.status !== AgentStatus.BROKER_WITH_CONTRACT}>
      <ChinaCompetitionFilter searchParams={searchParams} updateSearchParams={updateSearchParams} />

      <Card className="card-box">
        <ChinaCompetitionTable searchParams={searchParams} updateSearchParams={updateSearchParams} />
      </Card>
    </DisplayWrapper>
  );
};
